import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useDeleteAlarmCenterZone() {
  const {enqueueSnackbar} = useSnackbar()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [QueryKeyEnum.DELETE_ALARM_CENTER_ZONE],
    mutationFn: async (id: number) => {
      await api.alarmCenter.deleteZone(id)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [QueryKeyEnum.ALARM_CENTER_ZONES]})
      enqueueSnackbar('Zona removida com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos remover a zona no momento')
    },
  })
}
